<template>
  <div>
    <h5 class="card-subtitle">Attendance</h5>
    <br>
    <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
    <hr>
    <div class="card-block">
      <div class="table-responsive">
        <div class="panel panel-default filterable">
          <div class="">
            <div class="pull-left">
            <div>Subject Name : Farhan Tasks </div>
            <div>Schedule Time: 1/22/2022 4:00:00 PM </div>
            <div>Grade: 3 </div>
            <div>Class: Farhan  Muhammad Farhan</div>
            <div>Teacher Name : Muhammad Farhan </div>
            </div>
            <div class="pull-right"></div>
            <div style="clear:both"></div>
            <br>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
            <thead>
              <tr class="filters">
                <th>No</th>
                <th>Name</th>
                <th>Refresh Date</th>
                <th>Attended</th>
                <th>Check In</th>
                <th>Check Out</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody >
              <tr class="content" v-for="att in attendance" v-bind:key="att.id">
                <td style="width:50px">{{ att.id }}</td> 
                <td><h6>{{ att.name }}</h6></td>
                <td>{{ att.date }}</td>
                <td>
                  <div v-if="att.attend === Yes">
                    <CBadge color="success">{{ att.attend }}</CBadge>
                  </div>
                
                  <div v-else>
                    <CBadge color="danger">{{ att.attend }}</CBadge>
                  </div>
                </td>
                <td><h6>{{ att.chkin }}</h6></td>
                <td><h6>{{ att.chkout }}</h6></td>
                <td style="white-space: nowrap"> 
                  <input type="button" value="Set Attend" class="btn btn-success"> &nbsp;
                  <input style="display: inline-block;" type="submit" value="Set Not Attend" class="btn btn-danger">
                </td>
              </tr>
            </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>              
  </div>
</template>



<script>
import _ from "lodash";
import Vue from "vue";
import $ from "jquery";
Vue.use(require("vue-moment"));
import moment from "moment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);
import jQuery from "jquery";

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      attendance: [
        {
            id: "1",
            name: "Anak Farhan",
            date: "1/22/2022 4:00:00 PM",
            attend: "Yes",
            chkin: "No Checkin",
            chkout: "No Checkout",
            //action: "",
        },
        {
            id: "2",
            name: "Anak Shahira Binti Shahirah",
            date: "1/22/2022 4:00:00 PM",
            attend: "No",
            chkin: "No Checkin",
            chkout: "No Checkout",
        },
        {
            id: "3",
            name: "Anak Raja bin Raja Aqim",
            date: "1/22/2022 4:00:00 PM",
            attend: "No",
            chkin: "No Checkin",
            chkout: "No Checkout",
        },
        {
            id: "4",
            name: "Anak Nurul bt nurulhuda",
            date: "1/22/2022 4:00:00 PM",
            attend: "No",
            chkin: "No Checkin",
            chkout: "No Checkout",
        },
        {
            id: "5",
            name: "Faris tiada parent email",
            date: "1/22/2022 4:00:00 PM",
            attend: "No",
            chkin: "No Checkin",
            chkout: "No Checkout",
        },
      ]
    }
  },
}
</script>
